import { z } from 'zod';
/**
 * Health probe contract — consumed by apps/api (response) and deploy smoke checks.
 * Shape is fixed by the scaffold handoff: { status, service, version }.
 */
export const HealthResponseSchema = z.object({
    status: z.literal('ok'),
    service: z.string().min(1),
    version: z.string().min(1),
});
export const HEALTH_SERVICE_API = 'ctms-api';
export const HEALTH_SERVICE_WORKER = 'ctms-worker';
//# sourceMappingURL=health.js.map